import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-filter"
//
// Client-side "filter as you type" for a rendered table. Hides rows whose text
// doesn't contain the query; shows an empty-state note when nothing matches.
export default class extends Controller {
  static targets = ["input", "row", "empty"]

  filter() {
    const q = this.inputTarget.value.trim().toLowerCase()
    let visible = 0

    this.rowTargets.forEach(row => {
      const match = row.textContent.toLowerCase().includes(q)
      row.classList.toggle("d-none", !match)
      if (match) visible++
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("d-none", visible > 0)
  }
}
